import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { CollectionTarget } from '../../types/collection-targets'
import {
  ActionBar,
  Filters,
  LoadingSpinner,
  ResultCount,
  TargetsTable,
} from './collection-targets-table/collection-targets-table.parts'
import { useCollectionTargetsTable } from './collection-targets-table/use-collection-targets-table'

interface CollectionTargetsTableProps {
  targets: CollectionTarget[]
  loading?: boolean
  selectedIds: Set<string>
  onSelectionChange: (ids: Set<string>) => void
  isLocked?: boolean
  onAddTargets?: () => void
  onRemoveSelected?: () => void
  removingTargets?: boolean
}

export function CollectionTargetsTable(props: CollectionTargetsTableProps): ReactElement {
  const {
    targets,
    loading,
    selectedIds,
    onSelectionChange,
    isLocked = false,
    onAddTargets,
    onRemoveSelected,
    removingTargets = false,
  } = props
  const { t } = useTranslation('cases')
  const state = useCollectionTargetsTable({ targets, selectedIds, onSelectionChange })

  if (loading) return <LoadingSpinner />

  return (
    <div className="space-y-3">
      <ActionBar
        isLocked={isLocked}
        selectedCount={selectedIds.size}
        removingTargets={removingTargets}
        onAddTargets={onAddTargets}
        onRemoveSelected={onRemoveSelected}
        t={t}
      />
      <Filters
        searchQuery={state.searchQuery}
        setSearchQuery={state.setSearchQuery}
        statusFilter={state.statusFilter}
        setStatusFilter={state.setStatusFilter}
        t={t}
      />
      <ResultCount filteredCount={state.filtered.length} totalCount={targets.length} t={t} />
      <TargetsTable
        isLocked={isLocked}
        filtered={state.filtered}
        selectedIds={selectedIds}
        toggleAll={state.toggleAll}
        toggleOne={state.toggleOne}
        sortField={state.sortField}
        sortDir={state.sortDir}
        toggleSort={state.toggleSort}
        hasFilters={!!state.searchQuery || !!state.statusFilter}
        t={t}
      />
    </div>
  )
}
